import { atom } from "recoil";

export const IdSelectHosoState = atom({
  key: "IdSelectHosoState",
  default: undefined,
});
